import '../../assets/styles/login.css';
import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEyeSlash
} from "@fortawesome/free-solid-svg-icons";
import { changePassword } from '../../assets/constants/global_apis';
import { useNavigate } from "react-router-dom";


export default function UpdatePassword({ triggerAlert, setCurrentPage }) {
  const [reqData, setReqData] = useState({});
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const navigate = useNavigate();


  const handleChange = (e) => {
    const { name, value } = e.target;
    setReqData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    let init_password=localStorage.getItem('init_password');
    if(reqData.password1!=reqData.password) {
      triggerAlert('Error', 'Password mismatch');
    }else if(reqData.password.length<8){
      triggerAlert('Error', 'Password must be at least 8 characters');
    }else{
      changePassword({'password':reqData.password}).then((response) => {
          triggerAlert('Success', 'Password updated successfully');
          if(init_password=='true'){
            setCurrentPage('/new-user');
            navigate('/new-user');
          }else{
            localStorage.removeItem('authToken');
            localStorage.removeItem('role');
            localStorage.removeItem('init_password');
            navigate('/login');
          }
      }).catch((err) => {
        triggerAlert('Error', err.message);
      });
    }
  };



  return (
    <><form role="form" className="text-start"
      onSubmit={handleSubmit}
    >
      <div>
        <label>Password</label>
        <div className="mb-3">
          <input
            type="text"
            name='password1'
            className="form-control"
            placeholder="password"
            aria-label="Password"
            value={reqData?.password1}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <label>Confirm Password</label>
      <div className="mb-3 password-input">
        <input
          placeholder={"confirm password"}
          aria-label={"ConfirmPassword"}
          className={`form-control ${reqData?.password && reqData?.password!='' && reqData?.password.length>0 && reqData?.password!=reqData?.password1 && 'inputhoverBackground'}`}
          type={isPasswordVisible ? 'text' : 'password'}
          name='password'
          // style={{"0 0 0 .25rem rgba(253, 13, 13, 0.25)" : '0 0 0 .25rem rgba(13,110,253,.25)'}}
          value={reqData?.password}
          required
          onChange={handleChange}
        />
        <div className='password-visible-controller'>
          {
            isPasswordVisible ? <FontAwesomeIcon icon={faEye} onClick={() => setIsPasswordVisible(false)} style={{ marginLeft: '8%' }} /> :
              <FontAwesomeIcon icon={faEyeSlash} onClick={() => setIsPasswordVisible(true)} />
          }
        </div>
      </div>

      <div className="text-center">
        <button
          type="submit"
          className="btn bg-gradient-info w-100 mt-4 mb-0"
        >
          Update Password
        </button>
      </div>
    </form>
    </>
  );
}
